import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTeamDocument } from '../firebase/db';
import { getGameById } from '../firebase/db';

const StudentDashboard = () => {
    const navigate = useNavigate();
    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadTeams = async () => {
            const stored = JSON.parse(localStorage.getItem('studentTeams') || '[]');
            if (stored.length === 0) {
                setLoading(false);
                return;
            }

            const enriched = await Promise.all(
                stored.map(async (entry) => {
                    let gameInfo = null;
                    let teamDoc = null;

                    try {
                        teamDoc = await getTeamDocument(entry.teamName, entry.teamType);
                    } catch (err) {
                        console.error('Error fetching team:', err);
                    }

                    if (entry.gameId) {
                        try {
                            gameInfo = await getGameById(entry.gameId);
                        } catch (err) {
                            console.error('Error fetching game:', err);
                        }
                    }

                    return { ...entry, gameInfo, teamDoc, exists: !!teamDoc };
                })
            );

            setTeams(enriched.reverse()); // most recent first
            setLoading(false);
        };
        loadTeams();
    }, []);

    const handleRemove = (teamName, teamType) => {
        const stored = JSON.parse(localStorage.getItem('studentTeams') || '[]');
        const updated = stored.filter(
            t => !(t.teamName === teamName && t.teamType === teamType)
        );
        localStorage.setItem('studentTeams', JSON.stringify(updated));
        setTeams(prev => prev.filter(
            t => !(t.teamName === teamName && t.teamType === teamType)
        ));
    };

    if (loading) {
        return (
            <div style={{ padding: '20px', maxWidth: '700px', margin: '0 auto', textAlign: 'center', color: '#666' }}>
                Loading your games...
            </div>
        );
    }

    return (
        <div style={{ padding: '20px', maxWidth: '700px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
            <h1 style={{ textAlign: 'center', color: '#4b2e83' }}>My Games</h1>

            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                <button
                    onClick={() => navigate('/')}
                    style={{
                        padding: '10px 24px', backgroundColor: '#4b2e83', color: '#fff',
                        border: 'none', borderRadius: '6px', fontSize: '14px',
                        fontWeight: 'bold', cursor: 'pointer',
                    }}
                >
                    Join a Game
                </button>
            </div>

            {teams.length === 0 ? (
                <div style={{
                    textAlign: 'center', padding: '40px 20px', color: '#999',
                    fontStyle: 'italic', backgroundColor: '#f9f9f9', borderRadius: '8px',
                }}>
                    No teams found. Click "Join a Game" above to get started.
                </div>
            ) : (
                teams.map((team, i) => {
                    const rounds = team.teamDoc?.teamData?.rounds || [];
                    return (
                        <div
                            key={`${team.teamName}_${team.teamType}_${i}`}
                            style={{
                                padding: '16px', margin: '10px 0', borderRadius: '8px',
                                border: '1px solid #ddd', backgroundColor: team.exists ? '#fff' : '#fafafa',
                            }}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <div>
                                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: team.exists ? '#333' : '#999' }}>
                                        {team.teamName}
                                        <span style={{
                                            fontSize: '12px', fontWeight: 'normal', color: '#888',
                                            marginLeft: '8px',
                                        }}>
                                            ({team.teamType})
                                        </span>
                                    </div>

                                    {team.gameInfo ? (
                                        <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>
                                            {team.gameInfo.name}
                                            <span style={{
                                                display: 'inline-block', marginLeft: '10px',
                                                padding: '2px 8px', borderRadius: '10px', fontSize: '11px',
                                                fontWeight: 'bold', color: '#fff',
                                                backgroundColor: team.gameInfo.status === 'active' ? '#2e7d32' : '#e65100',
                                            }}>
                                                {team.gameInfo.status === 'active' ? 'Active' : 'Completed'}
                                            </span>
                                        </div>
                                    ) : team.gameCode ? (
                                        <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>
                                            Game code: {team.gameCode.toUpperCase()}
                                        </div>
                                    ) : (
                                        <div style={{ fontSize: '13px', color: '#999', marginTop: '4px', fontStyle: 'italic' }}>
                                            No game linked
                                        </div>
                                    )}

                                    {!team.exists && (
                                        <div style={{ fontSize: '12px', color: '#d32f2f', marginTop: '4px' }}>
                                            Team no longer exists
                                        </div>
                                    )}

                                    {team.exists && rounds.length > 0 && (
                                        <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                                            {rounds.map((round, ri) => (
                                                <div key={ri} style={{
                                                    display: 'flex', alignItems: 'center', gap: '4px',
                                                    fontSize: '12px', color: '#555',
                                                }}>
                                                    <span style={{
                                                        display: 'inline-block', width: '16px', height: '16px',
                                                        borderRadius: '50%', textAlign: 'center', lineHeight: '16px',
                                                        fontSize: '10px', fontWeight: 'bold', color: '#fff',
                                                        backgroundColor: round.is_submitted ? '#2e7d32' : '#bbb',
                                                    }}>
                                                        {round.is_submitted ? '\u2713' : '\u2022'}
                                                    </span>
                                                    Rd {ri + 1}
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {team.joinedAt && (
                                        <div style={{ fontSize: '11px', color: '#aaa', marginTop: '6px' }}>
                                            Joined {new Date(team.joinedAt).toLocaleDateString()}
                                        </div>
                                    )}
                                </div>

                                <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                                    {team.exists && (
                                        <button
                                            onClick={() => navigate(`/${team.teamName}_${team.teamType}/home`)}
                                            style={{
                                                padding: '8px 16px', backgroundColor: '#4b2e83', color: '#fff',
                                                border: 'none', borderRadius: '4px', cursor: 'pointer',
                                                fontSize: '13px', fontWeight: 'bold', whiteSpace: 'nowrap',
                                            }}
                                        >
                                            Continue Playing
                                        </button>
                                    )}
                                    <button
                                        onClick={() => handleRemove(team.teamName, team.teamType)}
                                        style={{
                                            padding: '8px 12px', backgroundColor: 'transparent', color: '#999',
                                            border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer',
                                            fontSize: '12px',
                                        }}
                                        title="Remove from list"
                                    >
                                        &times;
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })
            )}
        </div>
    );
};

export default StudentDashboard;
